export const isNumber = (value: string | number) => {
  return !Number.isNaN(Number(value))
}
